
import Http from './Http'

export default {
    async getNews(limit = 1000, lang= '',show_deleted = '',from_dashboard = '') {
        return await Http.get(`/content/news?limit=${limit}&lang=${lang}&show_deleted=${show_deleted}&from_dashboard=${from_dashboard}`);
    },
    async getNewsLanguage() {
        return await Http.get(`/content/news/lang`)
    },
    async removeNews(id) {
        return await Http.delete(`/content/news?source_id=${id}`)
    },
    async restoreNews(id) {
        return await Http.delete(`/content/restoreNews?source_id=${id}`)
    },
    async restoreVideo(id) {
        return await Http.delete(`/content/restoreVideos/${id}`)
    },
    async restoreShort(id) {
        return await Http.delete(`/content/restoreShorts/${id}`)
    },
    async getVideos(limit = 1000,show_deleted = 1,all = true) {
        return await Http.get(`/content/videos?limit=${limit}&show_deleted=${show_deleted}&all=${all}`)
    },
    async getShorts(limit = 10){
        return await Http.get(`/content/shorts?show_deleted=1&limit=${limit}`)
    },
    async removeShorts(id){
       return await Http.delete(`/content/shorts/${id}`)
    },
    async removeVideos(id) {
        return await Http.delete(`/content/videos/${id}`)
    },
    async fireEvent(data) {
        return await Http.post(`/content/fireEvent`, data)
    },
    async addBusinessNews(data) {
        return await Http.post(`/business/news`, data)
    },
    async getBusinessNews(limit = 1000,active = 'all',content_type, event_status='all', show_deleted = '') {
        return await Http.get(`/business/news?limit=${limit}&active=${active}&content_type=${content_type}&event_status=${event_status}&show_deleted=${show_deleted}`)
    },
    async getSingleBusinessNews(news_id,content_type) {
        return await Http.get(`/business/news?content_type=${content_type}&event_id=${news_id}`)
    },
    async deleteBusinessNews(news_id) {
        return await Http.delete(`/business/news/${news_id}`)
    },
    async restoreBusinessNews(source_id) {
        return await Http.delete(`/business/restoreNews?source_id=${source_id}`)
    },
    async editBusinessNews(news_id, data){
        return await Http.post(`/business/news/${news_id}`, data)
    },
    async getNewsFeed(lang= ''){
        return await Http.get(`/content/feed?lang=${lang}`)
    },
    async updateFeed(id, data){
        return await Http.post(`/content/feed/${id}`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })

    },
    async getBusinessEventmembers(event_id){
        return await Http.get(`/business/event/${event_id}/members/export`)
    },
    async getBusinessEventFieldsDefinition(){
        return await Http.get(`/business/event/fields`)
    },
    async getTenantContentTypes(){
        return await Http.get(`/content/tenantContentTypes`)
    },
    async updateTenantContentType(data){
        return await Http.patch(`/content/tenantContentType`, data)
    },
    async getEditorials(limit = 1000,active = 'all') {
        return await Http.get(`/content/editorials?limit=${limit}&active=${active}`)
    },
    async deleteEditorials(id) {
        return await Http.delete(`/content/editorials/${id}`)
    },
    async addEditorials(data) {
        return await Http.post(`/content/editorials`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async editEditorial(id, data){
        return await Http.post(`/content/editorials/${id}`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async addNewsArticle(data){
        return await Http.post(`/content/news`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async editNewsArticle(source_id,data){
        return await Http.post(`/content/news/${source_id}`, data, {
            headers: {
                'Content-Type':'multipart/form-data'
            }
	})
    },
    async uploadVideo(data) {
        return await Http.post(`/content/videos`,data,{
            headers:{
                'Content-Type':'multipart/form-data'
            }
        })
    },
    async editVideo(source_id,data) {
        return await Http.post(`/content/videos/${source_id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async uploadShort(data) {
        return await Http.post(`/content/shorts`,data,{
            headers:{
                'Content-Type':'multipart/form-data'
            }
        })
    },
    // UPPY METHODS START
    async createMultipartUpload(data){
        return await Http.post(`/content/createMultipartUpload`, data)
    },
    async signPart(data){
        return await Http.post(`/content/signPart`, data)
    },
    async completeMultipartUpload(data){
        return await Http.post(`/content/completeMultipartUpload`, data)
    },
    async abortMultipartUpload(data){
        return await Http.post(`/content/abortMultipartUpload`, data)
    },
    // UPPY METHODS END
    async processVideo(data){
        return await Http.post(`/content/processVideo`, data)
    },
    async getVideoProjects(){
        return await Http.get(`/content/processVideo`)
    },
    async deleteVideoProcess(processId) {
        return await Http.delete(`/content/processVideo/${processId}`)
    },
    async getProcessDetails(processId) {
        return await Http.get(`/content/processVideo?process_id=${processId}`)
    },
    async getVideoCuts(processId) {
        return await Http.get(`/content/videoCuts/${processId}`)
    },
    async updateVideoCut(cutId, data) {
        return await Http.patch(`/content/videoCuts/${cutId}`, data)
    },
    async getVideoUrl(processId) {
        return await Http.get(`/content/videoUrl/${processId}`)
    },
    // UPLOAD-POST (SOCIALS) METHODS START
    async getUploadPostProfile(username = '') {
        return await Http.get(`/content/socials/upload_post/profile?username=${username}`)
    },
    async getSocialAccounts() {
        return await Http.get(`/content/socials/social_accounts`)
    },
    async getUploadPostFacebookPages() {
        return await Http.get(`/content/socials/upload_post/facebook/pages`)
    },
    async getUploadPostLinkedinPages() {
        return await Http.get(`/content/socials/upload_post/linkedin/pages`)
    },
    async uploadPostConnectSocials(data) {
        return await Http.post(`/content/socials/upload_post/connect`, data)
    },
    async saveSocialAccounts() {
        return await Http.post(`/content/socials/social_accounts/save`)
    },
    async getUploadPostHistory() {
        return await Http.get(`/content/socials/post/content/history`)
    },
    async uploadPostUploadText(data) {
        return await Http.post(`/content/socials/upload_post/upload/text`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async uploadPostUploadPhotos(data) {
        return await Http.post(`/content/socials/upload_post/upload/photos`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async uploadPostUploadVideo(data) {
        return await Http.post(`/content/socials/upload_post/upload/video`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    async getUploadPostImpressions() {
        return await Http.get(`/content/socials/upload_post/analytics/impressions`)
    },
    async getUploadPostAnalytics(platforms = '', pageId = '') {
        let url = `/content/socials/upload_post/analytics?platforms=${platforms}`;
        if (pageId) {
            url += `&page_id=${pageId}`;
        }
        return await Http.get(url);
    },
    async getUploadPostSinglePostAnalytics(requestId = '') {
        return await Http.get(`/content/socials/upload_post/analytics/single_post?request_id=${requestId}`)
    }
    // UPLOAD-POST (SOCIALS) METHODS END
}


